module.exports = __webpack_public_path__ + "img/quick-treatment-icon.6c1af7f9.svg";